import { Routes } from '@angular/router';
import { QuoteSideResolver } from '@app/quote-side/quote-side.resolver';
import { VendorManifestResolver } from '@app/vendor-manifest/vendor-manifest.resolver';
import { AuthenticatedUserGuard, IsAdminGuard } from './core/guards/auth.guard';

export const appRoutes: Routes = [
  { path: '', redirectTo: '/quote-side/list', pathMatch: 'full' },
  {
    path: 'login',
    loadComponent: () => import('./login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'quote-side',
    loadChildren: () => import('./quote-side/quote-side.routes').then(m => m.QUOTE_SITE_ROUTES),
    canActivate: [AuthenticatedUserGuard],
    resolve: { data: QuoteSideResolver }
  },
  {
    path: 'vendor-manifest',
    loadChildren: () => import('./vendor-manifest/vendor-manifest.routes').then(m => m.VENDOR_MANIFEST_ROUTES),
    canActivate: [AuthenticatedUserGuard],
    resolve: { data: VendorManifestResolver }
  },
  {
    path: 'vendor-management',
    canActivate: [AuthenticatedUserGuard],
    loadChildren: () => import('./vendor-list/vendor-list.routes').then(m => m.VENDOR_LIST_ROUTES),
    canLoad: [IsAdminGuard]
  },
  {
    path: 'user-management',
    canActivate: [AuthenticatedUserGuard],
    loadChildren: () => import('./user-management/user-management.routes').then(m => m.USER_MANAGEMENT_ROUTES),
    canLoad: [IsAdminGuard]
  },
  {
    path: 'common',
    loadChildren: () => import('./common/common.routes').then(m => m.COMMON_ROUTES),
  },
  {
    path: 'communication',
    canActivate: [AuthenticatedUserGuard],
    loadChildren: () => import('./communication/communication.routes').then(m => m.COMMUNICATION_ROUTES)
  },
  {
    path: 'consent-attachments',
    loadChildren: () => import('./consent-attachments/consent-attachments.routes').then(m => m.CONSENT_ATTACHMENTS_ROUTES)
  },
  {
    path: 'administration',
    loadChildren: () => import('./administration/administration.routes').then(m => m.ADMINISTRATION_ROUTES),
    canLoad: [IsAdminGuard]
  },
  {
    path: 'messages',
    loadChildren: () => import('./messages/messages.routes').then(m => m.MESSAGES_ROUTES),
    canLoad: [IsAdminGuard]
  },
  { path: '**', redirectTo: 'login' }
];

